// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="\$ctrl.reportName"></sub-header>

  <form name="form" class="report-filters filters">
    <div ng-repeat="filter in \$ctrl.filters" class="filter-element">
      <div class="labelled-field filter day" ng-if="filter.type == 'DAY'">
        <label class="add-on">{{filter.label}}</label>
        <date ng-model="\$ctrl.parameters[filter.name]" ng-required="true" class="filter-value {{ 'filter-code-' + filter.name }}"></date>
      </div>

      <div class="labelled-field filter" ng-if="filter.type == 'SINGLE_CHOICE_LIST'">
        <label class="add-on">{{filter.label}}</label>
        <select
          ng-model="\$ctrl.parameters[filter.name]"
          ng-required="true"
          ng-options="entry for entry in filter.values"
          class="filter-value {{ 'filter-code-' + filter.name }}">
        </select>
      </div>
    </div>

    <button class="btn btn-success"
            type="button"
            ng-click="\$ctrl.generateReport()"
            ng-disabled="form.\$invalid">
      Generate
    </button>
  </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/report/custom-report/custom-report-detail.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;